import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Col, Form, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn, H4 } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { Export, Search, Filter, BinDeactiveReport, Bindeactives } from '../../Constant';
import { getAccount, getAccountRole, getBinDeactiveReportRole, getBinDeactiveReport, getStb, getStbRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import { EarningsSvg } from '../../Data/Widgets/General/Data';
import Progress from '../Common/Progress';
import { useForm } from 'react-hook-form';
import UserDropdown from '../Common Field/UserDropdown';
import AreaDropdown from '../Common Field/AreaDropdown';


const BinDeactive = () => {
    const authState = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const [filters, setFilters] = useState({
        searchKey: params.get('search') || '',
        start_date: params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : '',
        end_date: params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : '',
        areaFilter: params.get('area') || '',
    });
    const param1 = params.get("day") || '';
    const sortedBy = params.get("sortBy") || '';
    const sortedOrder = params.get("sortOrder") || '';
    const [customerLists, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
    const [startDate, endDate] = dateRange
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [apiAccount, setapiAccount] = useState([]);
    const [apiBin, setapiBin] = useState([]);
    const [totalsum, settotalsum] = useState("0");
    const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
    const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: { search: filters.searchKey, area: filters.areaFilter },
    });

    const StaticWidgetsData = [
        {
            id: 1,
            title: 'Paid',
            counter: totalsum,
            svg: <EarningsSvg />,
            class: 'progress-gradient-secondary',
            progress: '75%'
        },
    ];

    const BinDeactiveColumn = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            center: false,
            width: '80px'
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Name,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Bin Id</H4>,
            id: 'stb_no',
            selector: row => row.BinId,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Area</H4>,
            id: 'area_name',
            selector: row => row.Area,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4> Service Address</H4>,
            id: 'service_address',
            selector: row => row.Address,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Start Date</H4>,
            id: 'created_at',
            selector: row => row.StartDate,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Deactived At</H4>,
            id: 'status_date',
            selector: row => row.DeactiveDate,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Status</H4>,
            id: 'status',
            selector: row => row.Status,
            width: '100px',
            cell: row => (
                <div>
                    <span
                        className={`badge badge-${row.Status}`}
                    >
                        {row.Status}
                    </span>
                    {row.Status === 'disconnected' && (
                        <span>{row.StatusDate}</span>
                    )}
                </div>
            )
        },
    ];

    useEffect(() => {
        fetchCustomerPayment(1);
    }, []);

    useEffect(() => {
        setValue('search', filters.searchKey);
    }, [setValue, filters.search]);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/bin-deactive?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.areaFilter}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/bin-deactive?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.areaFilter}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const onSubmit = async (data) => {
        const searchKey = data.search || '';
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        const areaFilter = data.area || '';
        const queryParams = new URLSearchParams({
            search: searchKey,
            start_date,
            end_date,
            area: areaFilter,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/report/bin-deactive?${queryParams}`);
        setFilters({
            searchKey,
            start_date,
            end_date,
            areaFilter
        });
        fetchCustomerPayment(currentPage, perPage);
    };

    const fetchCustomerPayment = async (page, size = perPage) => {
        setLoading(true);
        setCustomerList([]);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1
            ? getBinDeactiveReport + `?page=${page}&page_length=${size}&search=${filters.searchKey}&area_id=${filters.areaFilter}
            &start_date=${formatStartDate}&end_date=${formatEndDate}&sort_by=${sortConfig.column ? sortConfig.column : ''}
            &sort_order=${sortConfig.order ? sortConfig.order : ''}`
            : getBinDeactiveReportRole + `?page=${page}&page_length=${size}&search=${filters.searchKey}
            &area_id=${filters.areaFilter}&start_date=${formatStartDate}&end_date=${formatEndDate}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`
        );
        if (response.status === true) {
            const valuePackages = response.data.data;
            const SerialNo = (page - 1) * size + 1;
            const newCustomerList = Object.keys(valuePackages).map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Name: valuePackages[e].customer_name,
                    BinId: valuePackages[e].stb_no,
                    Area: valuePackages[e].area_name,
                    Address: valuePackages[e].service_address,
                    StartDate: moment(valuePackages[e].created_at).format('DD/MM/YYYY'),
                    DeactiveDate: valuePackages[e].status_date,
                    Status: valuePackages[e].stb_status,
                };
            });
            // settotalsum(response.data.total);
            setCustomerList(newCustomerList);
            setTotalRows(response.data.total);
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getBinDeactiveReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getBinDeactiveReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ customer_name, stb_no, area_name, service_address, created_at, status_date, stb_status }, index) => ({ Sl: index + 1, Name: customer_name, Bin_Id: stb_no, Area: area_name, Service_address: service_address, Start_date: created_at, Deactivated_at: status_date, Status: stb_status }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Bin Deactive Data');
            XLSX.writeFile(wb, 'bin_deactive_report.xlsx');
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getBinDeactiveReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getBinDeactiveReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&area_id=${filters?.areaFilter ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ customer_name, stb_no, area_name, service_address, created_at, status_date, stb_status }, index) => ({ Sl: index + 1, customer_name, stb_no, area_name, service_address, created_at, status_date, stb_status }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Name", "Bin Id", "Area", "Address", "StartDate", "Deactived at", "Status",];
            const rows = dataToExport.map(({ customer_name, stb_no, area_name, service_address, created_at, status_date, stb_status }, index) => [index + 1, customer_name, stb_no, area_name, service_address, created_at, status_date, stb_status]);
            doc.autoTable({
                head: [columns],
                body: rows,
                columnStyles: {
                    7: { cellWidth: 20 }, // Amount column
                },
                styles: { fontSize: 10 },
                headStyles: { fillColor: [100, 150, 200] },
            });
            doc.save("bin_deactive_data.pdf");
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchCustomerPayment(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomerPayment(page, newPerPage);
        setPerPage(newPerPage);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={Bindeactives} parent="Reports" title={Bindeactives} />
            {/* <Progress details={StaticWidgetsData} /> */}
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{BinDeactiveReport}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionExcel()} ><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element" >
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <DatePicker
                                    className="form-control digits w-100"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    isClearable={true}
                                    monthsShown={2}
                                    popperPlacement="bottom"
                                    calendarClassName='parallel-calendar'
                                    placeholderText='Select Date Range'
                                />
                            </div>
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element">
                            <AreaDropdown
                                authState={authState}
                                registerName="area"
                                selectedAreaId={filters.areaFilter}
                                register={register}
                                setValue={setValue}
                            />
                        </Col>
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={BinDeactiveColumn}
                            data={customerLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default BinDeactive;